



















































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppTitleBar from '@/components/AppTitleBar.vue'
import AppTwoColsCard from '@/components/AppTwoColsCard.vue'

import { Common } from '@/mixins'

@Component({
  components: {
    AppTitleBar,
    AppTwoColsCard
  },
  apollo: {
    item: {
      query: gql`query ($itemId: ID!) {
        item(itemId: $itemId) {
          id
          isActive
          seller {
            id
            shop {
              id
              etc
              hours
              phone
              zipcode
              address
              extraAddress
            }
          }
          additionalInfo {
            notices {
              name
              value
            }
            safetyCertificationType
            certificationNo
          }
        }
      }`,
      variables () { return { itemId: this.$route.params.id } },
      async result ({ data }) {
        if (!data.item.isActive) {
          await this.routerReplace('/not-found')
        }
      }
    }
  }
})
export default class extends Mixins(Common) {
  item: { seller: { shop: {} }; additionalInfo: {} } = { seller: { shop: {} }, additionalInfo: {} }

  get shop () { return this.item.seller.shop }
  get additionalInfo () { return this.item.additionalInfo }

  safetyCertTypeText (type: string) {
    if (type === 'CERTIFICATION') return '안전인증'
    else if (type === 'CHECK') return '안전확인'
    else if (type === 'COMPATIBILITY_CHECK') return '공급자적합성확인'
    else return ''
  }
}
